import isNumber from "lodash/isNumber";
import isString from "lodash/isString";

const getDiffFormatValue = (
  value: number | string,
  keyFormat?: string,
): string | number => {
  if (keyFormat === "string") {
    if (isNumber(value)) {
      return value.toString();
    }
    return value;
  } else {
    if (isString(value)) {
      return Number(value);
    }
    return value;
  }
};

export default getDiffFormatValue;
